<template>
  <div id="containt" style="padding-left: 10px;">

    <div class="grid-height" style=" height: calc(100vh - -77px);">
      <vxe-grid align="center" show-overflow :stripe="true" :border="true" height="100%"
        :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
        @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

        <template #form>
          <div class="clearfix screen-btns" style="margin-top: 3px;">
            <div class="fl">
              <vxe-button v-if="parts_apply_report_export" status="primary" class="button-sty" icon="el-icon-plus" @click="doExcle">导出</vxe-button>
            </div>
            <div class="fr">
              <vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索</vxe-button>
            </div>
          </div>
          <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="requestParam"
            @submit="searchEvent" @reset="searchEvent">
            <vxe-form-item title="单据状态:">
              <template v-slot>
                <el-select
                  v-model="formData.statList"
                  multiple
                  :collapse-tags="true"
                  style="width:9vw ;"
                  placeholder="请选择">
                  <el-option :value="0" label="制单"/>
                  <el-option :value="1" label="申请"/>
                  <el-option :value="2" label="审核"/>
                  <el-option :value="3" label="已发货"/>
                  <el-option :value="4" label="已收货"/>
                  <el-option :value="9" label="驳回"/>
                  <el-option :value="98" label="已结算"/>
                  <el-option :value="99" label="取消"/>
                </el-select>
              </template>
            </vxe-form-item>
            <vxe-form-item title="订单类型:" field="name">
              <template v-slot>
                <el-select
                  v-model="formData.orderTypeList"
                  multiple
                  :collapse-tags="true"
                  style="width:9vw ;"
                  placeholder="请选择">
                  <el-option :value="1" label="收费订单"/>
                  <el-option :value="2" label="冲帐订单"/>
                  <el-option :value="3" label="免费订单"/>
                </el-select>
              </template>
            </vxe-form-item>
            <vxe-form-item title="计划类型:" field="name">
              <template v-slot>
                <el-select
                  v-model="formData.planTypeList"
                  multiple
                  style="width:9vw ;"
                  :collapse-tags="true"
                  placeholder="请选择">
                  <el-option :value="1" label="计划内"/>
                  <el-option :value="2" label="计划外"/>
                </el-select>
              </template>
            </vxe-form-item>
            <vxe-form-item title="申请类型:" field="name">
              <template v-slot>
                <el-select
                  v-model="formData.applyTypeList"
                  multiple
                  style="width:9vw ;"
                  :collapse-tags="true"
                  placeholder="请选择">
                  <el-option label="储备订单" :value="1"/>
                  <el-option label="加急单" :value="2"/>
<!--                  <el-option label="非常规" :value="3"/>-->
<!--                  <el-option label="延时申请" :value="4"/>-->
                </el-select>
              </template>
            </vxe-form-item>
            <vxe-form-item title="创建时间:" field="name" style="width:25%!important;">
              <template v-slot style=" display: inline-block;width:25%!important;">
                <el-date-picker style="width: 16vw;" v-model="formData.createTime" type="daterange" align="right"
                                unlink-panels range-separator="-" start-placeholder="开始日期"
                                end-placeholder="结束日期" :clearable="false"
                                :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                </el-date-picker>
              </template>
            </vxe-form-item>
            <vxe-form-item title="申请单号:">
              <template v-slot >
                <el-input v-model="formData.applyNo" size="small" clearable style="width:9vw ;"/>
              </template>
            </vxe-form-item>

            <vxe-form-item title="服务中心:">
              <template v-slot >
                <org-search :org-name.sync="formData.orgName"
                            :org-id-path.sync="formData.orgIdPath"
                            :org-id.sync="formData.orgId"
                            :show="!currentIsSite"
                            @change="() => {
                              formData.siteId = null
                              formData.siteName = null
                              formData.childSiteId = null
                              formData.childSiteName = null
                            }"
                            style="width:9vw ;"
                />
              </template>
            </vxe-form-item>

            <vxe-form-item title="服务商:">
              <template v-slot >
                <site-pop-search :site-id.sync="formData.siteId"
                                 :site-name.sync="formData.siteName"
                                 :org-name.sync="formData.orgName"
                                 :org-id-path.sync="formData.orgIdPath"
                                 :org-id.sync="formData.orgId"
                                 @valueChange="() => {formData.childSiteId = null; formData.childSiteName = null}"
                                 :editable="!currentIsSite"
                                 :param="{siteFloorLevel: 1}"
                                 style="width:9vw ;"/>
              </template>
            </vxe-form-item>

            <vxe-form-item title="下级服务商:">
              <template v-slot >
                <child-site-pop-search :site-id.sync="formData.childSiteId"
                                       :site-name.sync="formData.childSiteName"
                                       :parent-site-id.sync="formData.siteId"
                                       :org-name.sync="formData.orgName"
                                       :org-id-path.sync="formData.orgIdPath"
                                       :org-id.sync="formData.orgId"
                                       style="width:9vw ;"
                />
              </template>
            </vxe-form-item>
            <vxe-form-item title="审核时间:" field="name" style="width:25%!important;">
              <template v-slot style=" display: inline-block;width:25%!important;">
                <el-date-picker style="width: 16vw;" v-model="formData.checkTime" type="daterange" align="right"
                                unlink-panels range-separator="-" start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                </el-date-picker>
              </template>
            </vxe-form-item>
            <vxe-form-item title="工单号:">
              <template v-slot >
                <el-input v-model="formData.orderNo" size="small" clearable style="width:9vw ;"/>
              </template>
            </vxe-form-item>
            <vxe-form-item title="ERP单号:">
              <template v-slot >
                <el-input v-model="formData.sendNo" size="small" clearable style="width:9vw ;"/>
              </template>
            </vxe-form-item>
            <vxe-form-item title="交货单号:">
              <template v-slot >
                <el-input v-model="formData.collectNo" size="small" clearable style="width:9vw ;"/>
              </template>
            </vxe-form-item>
            <vxe-form-item title="物流单号:">
              <template v-slot >
                <el-input v-model="formData.deliverNo" size="small" clearable style="width:9vw ;"/>
              </template>
            </vxe-form-item>
            <vxe-form-item title="交货时间:" field="name" style="width:25%!important;">
              <template v-slot style=" display: inline-block;width:25%!important;">
                <el-date-picker style="width: 16vw;" v-model="formData.collectTime" type="daterange" align="right"
                                unlink-panels range-separator="-" start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                </el-date-picker>
              </template>
            </vxe-form-item>
          </vxe-form>
        </template>
        <!-- 分页器 -->
        <template #pager>
          <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
        </template>

        <template #stat="{ row }">
          <span class="txt-status " v-if="row.stat == 0">制单</span>
          <span class="txt-status " v-else-if="row.stat == 1">申请</span>
          <span class="txt-status neutral" v-else-if="row.stat == 2">审核</span>
          <span class="txt-status " v-else-if="row.stat == 3">已发货</span>
          <span class="txt-status " v-else-if="row.stat == 4">已收货</span>
          <span class="txt-status disable" v-else-if="row.stat == 9">驳回</span>
          <span class="txt-status " v-else-if="row.stat == 98">已结算</span>
          <span class="txt-status disable" v-else-if="row.stat == 99">取消</span>
          <span v-else></span>
        </template>

        <template #collectStat="{ row }">
          <span v-if="row.collectStat == 0" class="txt-status">未交货</span>
          <span v-else-if="row.collectStat == 1" class="txt-status neutral">部分交货</span>
          <span v-else-if="row.collectStat == 2" class="txt-status neutral">完全交货</span>
          <span v-else></span>
        </template>

        <template #areaSlots="{ row }">
          <span>{{ row.deliverProvince }}{{ row.deliverCity }}{{ row.deliverCounty }}{{ row.deliverTown }}</span>
        </template>

        <template #outTypeSlots="{ row }">
          <span v-if="row.outType == 1">总部</span>
          <span v-else-if="row.outType == 2">中心</span>
        </template>

        <template #outStatSlots="{ row }">
          <span v-if="row.outStat == 0">未发货</span>
          <span v-else-if="row.outStat == 1">部分发货</span>
          <span v-else-if="row.outStat == 2">完全发货</span>
        </template>

        <template #getStatSlots="{ row }">
          <span v-if="row.getStat == 0">未收货</span>
          <span v-else-if="row.getStat == 1">部分收货</span>
          <span v-else-if="row.getStat == 2">完全收货</span>
        </template>

        <template #send1FlagSlots="{ row }">
          <span v-if="row.send1Flag == 1" class="txt-status disable">失败</span>
          <span v-else-if="row.send1Flag == 2" class="txt-status neutral">已传</span>
          <span v-else-if="row.send1Flag == 0" class="txt-status">未传</span>
        </template>

        <template #checkStatSlots="{ row }">
          <span v-if="row.checkStat == 5" class="txt-status">待审批</span>
          <span v-if="row.checkStat == 0" class="txt-status neutral">已审核</span>
          <span v-if="row.checkStat == 6" class="txt-status disable">不通过</span>
        </template>

        <template #collectStatSlots="{ row }">
          <span v-if="row.stat == 1" class="txt-status">待发货</span>
          <span v-if="row.stat == 3" class="txt-status neutral">已发货</span>
          <span v-if="row.stat == 99" class="txt-status disable">取消</span>
        </template>
        <template #showPriceCheck ="{ row }">
          <span v-if="currentIsSite">*</span>
          <span v-else>{{row.sitePrice}}</span>
        </template>
      </vxe-grid>
    </div>

  </div>
</template>

<script>
import { initVxeTable } from '@/const/crud/admin/table'
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import OrgSearch from "@/components/formItem/orgSearch.vue";
import SitePopSearch from "@/components/formItem/sitePopSearch.vue";
import ChildSitePopSearch from "@/components/formItem/childSitePopSearch.vue";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import {siteMixins} from "@/mixins/tabChang";
import {mapGetters} from "vuex";
// import { initVxeTable } from '@/const/crud/admin/fakeDataTable'

export default {
  mixins: [siteMixins],
  name: 'partsApplyReport',

  components: {ChildSitePopSearch, SitePopSearch, OrgSearch, pager },
  data() {
    return {
      parts_apply_report_export: false,

      getPageDataUrl: '/basic/basCompanyBarcode/getListPage',
      showEdit: false,
      editViewDataUpdateFlag: false,
      activeName: 'second',
      dataId: 0,
      pageSizes: [10, 20, 100],
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 10,  // 页面数据量

        statList: null,
        orderTypeList: null,
        planTypeList: null,
        applyTypeList: null,
        createTime: null,
        applyNo: null,
        orgIdPath: null,
        siteId: null,
        childSiteId: null,
        checkTime: null,
        orderNo: null,
        sendNo: null,
        collectNo: null,
        deliverNo: null,
        collectTime: null,
      },
      formData: {
        statList: null,
        orderTypeList: null,
        planTypeList: null,
        applyTypeList: null,
        createTime: null,
        applyNo: null,
        orgIdPath: null,
        siteId: null,
        childSiteId: null,
        checkTime: null,
        orderNo: null,
        sendNo: null,
        collectNo: null,
        deliverNo: null,
        collectTime: null,
      },
      searchBarcode: '',
      searchItemCode: '',
      searchItemName: '',
      total: 0,  // 数据总数
      vxeOption: {},
      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      columns: [
        {title: '申请单号', field: 'applyNo', width: 180, },
        {title: '状态', field: 'stat', width: 125, slots: {default: 'stat'}},
        {title: '服务中心', field: 'orgName', width: 100,},
        {title: '服务商', field: 'siteName', width: 100,},
        // {{ row.deliverProvince }}{{ row.deliverCity }}{{ row.deliverCounty }}{{ row.deliverTown }},
        {title: '省', field: 'deliverProvince', width: 80,},
        {title: '市', field: 'deliverCity', width: 80,},
        {title: '区', field: 'deliverCounty', width: 80,},
        {title: '镇', field: 'deliverTown', width: 80,},
        {title: '详细地址', field: 'deliverAddress', width: 120,},
        {title: '申请备注', field: 'remark', width: 80,},
        {title: '发出类型', field: 'outType', width: 80, slots: {default: 'outTypeSlots'}},
        {title: '交货状态', field: 'collectStat', width: 125, slots: {default: 'collectStatSlots'}},
        {title: '发货状态', field: 'outStat', width: 90, slots: {default: 'outStatSlots'}},
        {title: '收货状态', field: 'getStat', width: 90, slots: {default: 'getStatSlots'}},
        {title: '产品大类', field: 'categoryName', width: 90, },
        {title: '配件编码', field: 'partsCode', width: 90, },
        {title: '配件名称', field: 'partsName', width: 90, },
        {title: '价格', field: 'sitePrice', width: 90, slots:{default: 'showPriceCheck'}},
        {title: '申请数量', field: 'applyQty', width: 80,},
        {title: '审核数量', field: 'checkQty', width: 80,},
        {title: '交货数量', field: 'collectQty', width: 80,},
        {title: '发货数量', field: 'outQty', width: 80,},
        {title: '收货数量', field: 'getQty', width: 80,},
        {title: '提交日期', field: 'commitDate', width: 80,},
        {title: '审核日期', field: 'checkDate', width: 80,},
        {title: '交货日期', field: 'send1Date', width: 80,},
        {title: '发货日期', field: 'send2Date', width: 80,},
        {title: '出库仓', field: 'outWarehouseName', width: 80,},
        {title: 'ERP单号', field: 'sendNo', width: 90, },
        {title: '审批状态', field: 'checkStat', width: 90, slots: {default: 'checkStatSlots'}},
        {title: '行备注', field: 'lineRemark', width: 90, },
        {title: '审核备注', field: 'checkRemark', width: 90, },
        {title: '工单号', field: 'orderNo', width: 90, },
        {title: '工单对应服务商', field: 'orderSiteName', width: 90, },
        {title: '计划单号', field: 'planNo', width: 90, },
        {title: '交货单号', field: 'collectNo', width: 90, },
        {title: 'ERP交货单号', field: 'send1No', width: 90, },
        {title: '交货数量', field: 'collectHeaderQty', width: 90, },
        {title: '物流公司', field: 'deliverCompanyName', width: 120,},
        {title: '物流单号', field: 'deliverNo', width: 120,},
        {title: '揽收时间', field: 'collectingDate', width: 150,},
        {title: '计划到达时间', field: 'etaDate', width: 150,},
        {title: '创建人', field: 'createBy', width: 80,},
        {title: '创建时间', field: 'createTime', width: 150,},
      ],
    };
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    }
  },
  created() {
    this.parts_apply_report_export = this.permissions['parts_apply_report_export']
  },
  mounted() {
    this.initSearchDate()
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    setSiteData() {
      this.formData.siteId = this.currentSiteData.id
      this.formData.siteName = this.currentSiteData.userName
      this.formData.orgIdPath = this.currentSiteData.snSiteInfoDTO.orgIdPath
      this.formData.orgId = this.currentSiteData.snSiteInfoDTO.orgId
      this.formData.orgName = this.currentSiteData.snSiteInfoDTO.orgName
      this.$objCopy(this.formData, this.requestParam)
    },

    //导出
    doExcle(){
      this.$mask.open()
      doCheckExcle(fileNames.applyPartsReport).then(response => {
        if (response.data.msg=="success"){
          doDownLoadExcle(api.partsApplyReport.doExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          }).catch(() => {
            this.$mask.close()
          })
        }else{
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },
    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.createTime = [start, end]
      this.requestParam.createTime = [start, end]
    },
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      // const fields = ['applyQty', 'checkQty', 'collectQty', 'outQty', 'getQty']
      const cellValue = row[column.property]
      // if (cellValue && !fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      // }
    },
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.partsApplyReport.getPage,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.searchBarcode = ''
      this.searchItemName = ''
      this.searchItemCode = ''
      this.requestParam.searchCount = false
      this.requestParam.barcode = ''
      this.requestParam.itemCode = ''
      this.requestParam.itemName = ''
      this.requestParam.current = 1
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 新增
    openEditDialog(id) {
      console.log(id)
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
  }
};
</script>
<style lang="scss" >
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}


</style>
